// Public root for remote.ots.chat. The operator never browses here — they
// drive the system from the Mac Electron console. Students arrive at /s/:token.
// Keep this intentionally bare; no brand, no nav, no surface area.

export default function Home({ unknown = false }: { unknown?: boolean }) {
  return (
    <div className="home">
      <p className="ghost">{unknown ? '404' : 'Nothing to see here.'}</p>
    </div>
  );
}
